"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreadCountResponseSchema = exports.ListNotificationsQuerySchema = exports.ListNotificationsResponseSchema = exports.NotificationSchema = exports.DeletePushTokenSchema = exports.RegisterPushTokenSchema = exports.EntityType = exports.NotificationType = void 0;
const zod_1 = require("zod");
var NotificationType;
(function (NotificationType) {
    NotificationType["QUOTE_SENT"] = "QUOTE_SENT";
    NotificationType["QUOTE_ACCEPTED"] = "QUOTE_ACCEPTED";
    NotificationType["QUOTE_REJECTED"] = "QUOTE_REJECTED";
    NotificationType["QUOTE_CHANGES_REQUESTED"] = "QUOTE_CHANGES_REQUESTED";
    NotificationType["INVOICE_SENT"] = "INVOICE_SENT";
    NotificationType["INVOICE_PAID"] = "INVOICE_PAID";
    NotificationType["INVOICE_OVERDUE"] = "INVOICE_OVERDUE";
    NotificationType["JOB_SCHEDULED"] = "JOB_SCHEDULED";
    NotificationType["JOB_COMPLETED"] = "JOB_COMPLETED";
    NotificationType["APPOINTMENT_REMINDER"] = "APPOINTMENT_REMINDER";
    NotificationType["USER_INVITED"] = "USER_INVITED";
    NotificationType["SUBSCRIPTION_EVENT"] = "SUBSCRIPTION_EVENT";
    NotificationType["TODO_ASSIGNED"] = "TODO_ASSIGNED";
    NotificationType["TODO_STATUS_CHANGED"] = "TODO_STATUS_CHANGED";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var EntityType;
(function (EntityType) {
    EntityType["QUOTE"] = "QUOTE";
    EntityType["INVOICE"] = "INVOICE";
    EntityType["JOB"] = "JOB";
    EntityType["APPOINTMENT"] = "APPOINTMENT";
    EntityType["USER"] = "USER";
    EntityType["SUBSCRIPTION"] = "SUBSCRIPTION";
    EntityType["TODO"] = "TODO";
})(EntityType || (exports.EntityType = EntityType = {}));
exports.RegisterPushTokenSchema = zod_1.z.object({
    token: zod_1.z.string(),
    platform: zod_1.z.enum(['ios', 'android']),
});
exports.DeletePushTokenSchema = zod_1.z.object({
    token: zod_1.z.string(),
});
exports.NotificationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.nativeEnum(NotificationType),
    title: zod_1.z.string(),
    body: zod_1.z.string(),
    entityId: zod_1.z.string().nullable(),
    entityType: zod_1.z.nativeEnum(EntityType).nullable(),
    data: zod_1.z.record(zod_1.z.string()).nullable(),
    readAt: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
});
exports.ListNotificationsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.NotificationSchema),
    meta: zod_1.z.object({
        total: zod_1.z.number(),
        hasMore: zod_1.z.boolean(),
    }),
});
exports.ListNotificationsQuerySchema = zod_1.z.object({
    cursor: zod_1.z.string().optional(),
    limit: zod_1.z.string().optional(),
});
exports.UnreadCountResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        count: zod_1.z.number(),
    }),
});
